// import React, { useEffect, useRef, useState } from 'react';
// import { BoxWrapper } from '../../../style';
// import congratulations from "../../../images/congratulations.gif";
// import { useNavigate } from 'react-router-dom';
// import { getStorage } from '../../../Utils/common';

// const GOOGLE_ADS_CONVERSION_ID = "AW-18087709747/xKH2CIXgl5wcELOY8rBD";

// function ThankYou() {
//   const navigate = useNavigate();
//   const [progressBar, setProgressBar] = useState(getStorage('percent'));
//   const hasTrackedConversion = useRef(false);

//   useEffect(() => {
//     if (typeof window !== "undefined" && typeof window.fbq === "function") {
//       window.fbq("track", "PageView");
//     }
//   }, []);

//   useEffect(() => {
//     if (
//       hasTrackedConversion.current ||
//       typeof window === "undefined" ||
//       typeof window.gtag !== "function"
//     ) {
//       return;
//     }

//     hasTrackedConversion.current = true;

//     window.gtag("event", "conversion", {
//       send_to: GOOGLE_ADS_CONVERSION_ID,
//       value: 1.0,
//       currency: "INR",
//     });
//   }, []);

//   return (
//     <div>
//       <BoxWrapper className="w100 gray">
//         <div
//           className="formmainBox flex"
//           style={{
//             backgroundImage: `url(${congratulations})`,
//             backgroundSize: 'cover',
//             height: '615px',
//             width: '100%',
//             backgroundPosition: 'center',
//             backgroundRepeat: 'no-repeat'
//           }}
//         >
//           <div className="left">
//             {/* Any other content you want to show */}
//           </div>
//         </div>
//       </BoxWrapper>
//     </div>
//   );
// }

// export default ThankYou;

import { CheckCircle } from "lucide-react";
import { goBack } from '../../../Utils/common';
import { useNavigate } from 'react-router-dom';

export default function LoanSuccess() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen  flex items-center justify-center px-4 py-10">
      <div className="bg-white shadow-2xl rounded-3xl max-w-5xl w-full overflow-hidden">

        <div className="flex justify-center items-center">

          {/* Left Section */}
          <div className="p-8 md:p-12 text-center flex flex-col items-center">

            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-6">
              <CheckCircle className="text-green-600" size={38} />
            </div>

            <h1 className="text-3xl md:text-5xl font-bold text-[#173A7A] leading-tight">
              Thank You!
            </h1>

            <h2 className="text-2xl font-semibold text-blue-600 mt-2">
              Loan Application Submitted
            </h2>

            <p className="mt-6 text-gray-600 leading-7">
              We have successfully received your loan application.
              Our team is reviewing your details and will contact you shortly.
            </p>

            <div className="mt-8 bg-blue-50 rounded-xl p-4 border border-blue-100">

              <div className="text-sm text-gray-500 font-semibold text-green-600 mt-1">
                Application Status

                Under Review

              </div>


            </div>

            <button onClick={() => goBack(navigate, "/my-dashboard")} className="mt-8 bg-[#173A7A] hover:bg-blue-900 text-white px-8 py-3 rounded-xl font-semibold transition">
              Back to Dashboard
            </button>

          </div>

          {/* Right Section */}



        </div>

      </div>
    </div>
  );
}